import { createContext } from 'react';

import { SmartReactContextType } from './types';

export const SmartReactContext = createContext<SmartReactContextType | Record<string, never>>({});
